import { connect } from "react-redux";
import { default as Sidebar } from "./Sidebar";

// actions
import { beginNextStep, beginPreviousStep } from "store/actions/specifications";

const mapStateToProps = (state) => ({
    step: state.specifications.page.step.current,
    loading: state.specifications.page.loading,
});

const mapDispatchToProps = { beginNextStep, beginPreviousStep };

export default connect(mapStateToProps, mapDispatchToProps)(Sidebar);
